import { useSearchParams, useNavigate } from "react-router-dom"
import logo from "../../assets/images/linkWrong.png"
import InputField from "../../components/InputField/InputField"
import Button from "../../components/Button/Button"
import { faKey } from "@fortawesome/free-solid-svg-icons"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"
import Menu from "../../components/Menu/Menu"
import { PATH_MAP } from "../../configuration/PathMap"
import { useTranslation } from "react-i18next"
import { useResetPassword } from "../../hooks/Components/useResetPassword"
import { API_ROUTES } from "../../configuration/RoutesApi"

export default function ResetPasswordPage() {
  const { t } = useTranslation("resetPassword")

  const [params] = useSearchParams()

  const navigate = useNavigate()

  const email = params.get("email")

  const token = params.get("token")

  const accountType = params.get("accountType")

  const isCourier = accountType === "courier"

  const isReseller = accountType === "reseller"

  const { password, setConfirmPassword, setPassword, confirmPassword, HandleSaveNewPassword } = useResetPassword()

  if (!email || !token) {
    return (
      <Animate type={AnimationTypes.fadeIn}>
        <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 relative">
          <Menu />

          <Animate type={AnimationTypes.fadeInTraslate} duration="1.2s">
            <img src={logo} className="w-32 mb-6" />
          </Animate>

          <h2 className="text-xl font-extrabold bg-gradient-to-r from-red-500 to-orange-400 bg-clip-text text-transparent text-center">
            {t("label_invalid_link")}
          </h2>
        </div>
      </Animate>
    )
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (password !== confirmPassword) {
      alert(t("alert_wrong_password"))
      return
    }

    const route = isCourier ? API_ROUTES.DELIVERY.TRY_CHANGE_COURIER_PASSWORD : API_ROUTES.AUTH.TRY_CHANGE_PASSWORD

    const destination = isCourier
      ? PATH_MAP.COURIER_PANEL_PAGE
      : isReseller
        ? PATH_MAP.RESELLER_LOGIN_PAGE
        : PATH_MAP.ROOT_LOGIN

    await HandleSaveNewPassword(email, token, () => navigate(destination), route)
  }

  return (
    <Animate type={AnimationTypes.fadeIn}>
      <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 relative">
        <Menu />

        <Animate type={AnimationTypes.fadeInTraslate} duration="1.2s">
          <div className="w-full max-w-md bg-white shadow-xl rounded-2xl p-8 border border-gray-100">
            {/* Logo */}
            <div className="flex justify-center mb-6">
              <img src={logo} className="w-28" />
            </div>

            {/* Título */}
            <h1 className="text-2xl font-bold text-center mb-6 bg-gradient-to-r from-red-500 to-orange-400 bg-clip-text text-transparent">
              {t("label_title_reset_password")}
            </h1>

            <form onSubmit={handleSubmit} className="space-y-4">
              <InputField
                icon={faKey}
                type="password"
                value={password}
                placeholder={t("label_password_place_holder")}
                onInvalidMessage={t("label_password_onInvalidMessage")}
                onChange={(e) => setPassword(e.target.value)}
                required
                descriptionKey="interactionDescriptions:pages.resetPasswordPage.resetPasswordPage.input.passwordPlaceHolder"
              />

              <InputField
                icon={faKey}
                type="password"
                value={confirmPassword}
                placeholder={t("label_confirm_password_place_holder")}
                onInvalidMessage={t("label_confirm_password_onInvalidMessage")}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                descriptionKey="interactionDescriptions:pages.resetPasswordPage.resetPasswordPage.input.confirmPasswordPlaceHolder"
              />

              <Button
                label={t("buttons:button_recover_password")}
                type="primary"
                size="large"
                typeButton="submit"
                animationDuration="2s"
                onClick={() => {}}
                bgColor="#ef4444"
                descriptionKey="interactionDescriptions:pages.resetPasswordPage.resetPasswordPage.button.recoverPassword"
              />
            </form>
          </div>
        </Animate>
      </div>
    </Animate>
  )
}
